module.exports = __webpack_public_path__ + "static/media/s10.b821e26e.jpg";